export const DATA_UNIT_PRODUCT_KEYS = {
  personBasicData: 'person_basic_data',
  personFinancialData: 'person_financial_data',
  personOwnedCompanies: 'person_owned_companies',
  personLawsuits: 'person_lawsuits',
  personEmails: 'person_emails',
  personPhones: 'person_phones',
  personAddresses: 'person_addresses',
  companyLawsuits: 'company_lawsuits',
  companyMediaAi: 'company_media_ai',
  personMediaAi: 'person_media_ai',
  companyCertificates: 'company_certificates',
  personCertificates: 'person_certificates',
  personLawsuitsNovo: 'person_lawsuits_novo',
  companyLawsuitsNovo: 'company_lawsuits_novo',
  personGlobalScreening: 'person_global_screening',
  companyGlobalScreening: 'company_global_screening',
} as const;

export type DataUnitProductKey = typeof DATA_UNIT_PRODUCT_KEYS[keyof typeof DATA_UNIT_PRODUCT_KEYS];
